module.exports = __webpack_public_path__ + "img/activities-w.svg";